import { useState } from 'react';
import styled from '@emotion/styled';

import { BasicFlex } from '../../../utils/Common';

import { IconButton } from '@mui/material';

import { startCase } from 'lodash';

import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';

import SimpleChip from '../../../utils/utilities/SimpleChip';

const List = styled(BasicFlex)`
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  height: ${props => props.$show ? "auto" : "1.6rem"};
  overflow-y: hidden;
`

const Item = styled.span`
  font-size: 1.2rem;
  /* font-weight: 500; */
`

const ItemType = styled.span`
  font-size: 1.2rem;
  color: ${p => p.theme.colors.lightText};
`

const Qty = styled.span`
  font-size: 1.2rem;
  color: ${p => p.theme.colors.mildText};
  font-weight: 500;
  padding-left: .5rem;
`

const MoreTag = styled.div`
  font-size: 1.2rem;
  color: ${p => p.theme.colors.mildText};
  font-weight: 500;
  width: max-content;
`

const LineItemList = ({ line_items }) => {
  const [open, setOpen] = useState(false);

  const handleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(!open);
  }


  return (
    <BasicFlex gap=".5rem">

      <List $show={open}>
        {line_items.map(({id, name, qty, item_type}, i) => (
          <BasicFlex key={id} justify="flex-start" gap=".5rem">
            <Item>{name}</Item>
            <BasicFlex width="fit-content">
            {/* <ItemType>{startCase(item_type)}</ItemType> {qty > 1 ? <Qty> x{qty}</Qty> : null} */}
            </BasicFlex>
          </BasicFlex>
        ))}
      </List>

      {line_items?.length > 1 ? <BasicFlex width="fit-content">
      <MoreTag onClick={handleExpand}>+{line_items.length - 1} more</MoreTag>
      <IconButton size="small" sx={{padding: ".2rem"}} onClick={handleExpand}>
        {open ? <KeyboardArrowDownRoundedIcon /> : <KeyboardArrowRightRoundedIcon />}
      </IconButton></BasicFlex> : null }
     
    </BasicFlex>
  );
};

export default LineItemList;